/* Vendors */
import * as moment from 'moment'
import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { find } from 'lodash'
import PropTypes from 'prop-types'
import EditIcon from '@material-ui/icons/Edit'
import AddIcon from '@material-ui/icons/Add'

import { Link } from 'react-router-dom'

/* Actions */
import {
  getPickupTimesByCityId,
  removePickupTime,
  savePickupTimesList,
} from 'Reducers/PickupTimes/actions'

/* Components */
import { ManagePickupTimesWrapper } from 'Components/City/Page/ManagePickupTimes/ManagePickupTimesWrapper'
import { ManagePickupTimesSectionTitleWrapper } from 'Components/City/Page/ManagePickupTimes/ManagePickupTimesSectionTitleWrapper'
import { ManagePickupTimesTable } from 'Components/City/Page/ManagePickupTimes/ManagePickupTimesTable'
import { ManagePickupTimesButtons } from 'Components/City/Page/ManagePickupTimes/ManagePickupTimesButtons'

import { Table } from 'Components/Table'
import { Td } from 'Components/Table/Td'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'
import { SectionTitle } from 'Components/Section/SectionTitle'

import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { LinkDelete } from 'Components/LinkDelete'
import { LocationsWrapper } from 'Components/City/Page/Locations/LocationsWrapper'

/* Containers */
import PickupTimesAddModal from 'Containers/City/Page/PickupTimes/PickupTimesAdd'
import CityPage from 'Containers/City/Page'

import { cancelPickupTime } from 'Reducers/PickupTimes/actions'
import * as CONST from 'Reducers/PickupTimes/const'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'
import SubmitButton from '../../../../Components/Form/SubmitButton/index'
import { sortTimesItems } from '../utils'

/**
 * TODO: check if this component needed to be inside Pickup Component
 */
class ManagePickupTimes extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalAddShow: false,
    }

    this.handleModalAddShow = this.handleModalAddShow.bind(this)
    this.handleModalAddCancel = this.handleModalAddCancel.bind(this)
    this.handleModalAddConfirm = this.handleModalAddConfirm.bind(this)
  }

  componentDidMount() {
    const { getPickupTimesByCityId, cityId } = this.props

    getPickupTimesByCityId(cityId)
  }

  render() {
    const { modalAddShow } = this.state
    return (
      <CityPage
        active={this.props.nav}
        cityId={this.props.cityId}
        history={this.props.history}
        match={this.props.match}
        cityName={this.props.cityName}
      >
        <Link to={`${this.props.match.url}/edit`} className="link-edit-main">
          <StyledIconButton>
            <EditIcon />
          </StyledIconButton>
        </Link>
        <LocationsWrapper>
          <LayoutDashboard>
            <ManagePickupTimesSectionTitleWrapper>
              <SectionTitle className="title">Manage Pickup Times</SectionTitle>
              <StyledIconButton
                className="add-new-time"
                onClick={this.handleModalAddShow}
              >
                <AddIcon />
              </StyledIconButton>
            </ManagePickupTimesSectionTitleWrapper>
          </LayoutDashboard>

          {this.props.pickupTimesList.length > 0 && (
            <ManagePickupTimesWrapper>
              {this.renderPickupTimesTable()}
            </ManagePickupTimesWrapper>
          )}
          {this.renderPickupTimesButtons()}
          <PickupTimesAddModal
            handleCancel={this.handleModalAddCancel}
            handleConfirm={this.handleModalAddConfirm}
            modalShow={modalAddShow}
          />
        </LocationsWrapper>
      </CityPage>
    )
  }

  handleSave = e => {
    e.preventDefault()
    const { pickupTimesList, cityId, savePickupTimesList } = this.props
    const formData = this.transformToFormData(pickupTimesList)

    const data = {
      formData,
      cityId,
    }

    savePickupTimesList(data)
  }

  handleModalAddShow() {
    this.setState({
      modalAddShow: true,
    })
  }

  handleModalAddConfirm() {
    this.setState({
      modalAddShow: false,
    })
  }

  handleModalAddCancel() {
    this.setState({
      modalAddShow: false,
    })
  }

  transformToFormData(pickupTimesList) {
    let payload = []

    pickupTimesList.forEach(pickupTime => {
      const transformed = {
        day: find(CONST.DAYS_OF_THE_WEEK, ['label', pickupTime.day]).label,
        time_start: moment(
          pickupTime.timeStart,
          CONST.TIME_FORMATS.HOURS_MINUTES,
        ).format(CONST.TIME_FORMATS.HOURS_MINUTES),
        time_stop: moment(
          pickupTime.timeStop,
          CONST.TIME_FORMATS.HOURS_MINUTES,
        ).format(CONST.TIME_FORMATS.HOURS_MINUTES),
      }
      payload.push(transformed)
    })

    return payload
  }

  /**
   * Renders buttons cancel and save
   * @returns JSX.Element[]
   */
  renderPickupTimesButtons() {
    const { initialPickupTimesList, pickupTimesList } = this.props
    return (
      ((initialPickupTimesList.length === 0 && pickupTimesList.length > 0) ||
        initialPickupTimesList.length > 0) && (
        <ManagePickupTimesButtons>
          <Grid fluid>
            <Row>
              <Col xs={12}>
                <Link to="pickup">
                  <SubmitButton value="cancel" className="cancelButton" />
                </Link>
                <SubmitButton
                  value="Save"
                  className="saveButton"
                  onClick={this.handleSave}
                />
              </Col>
            </Row>
          </Grid>
        </ManagePickupTimesButtons>
      )
    )
  }

  /**
   * Renders pickupTimes table
   * @returns JSX.Element[]
   */
  renderPickupTimesTable() {
    return (
      <ManagePickupTimesTable>
        <Table>
          {this.renderPickupTimesTableHeader()}
          {this.renderPickupTimesTableRows()}
        </Table>
      </ManagePickupTimesTable>
    )
  }

  /**
   * Renders pickupTimes table header
   * @returns JSX.Element[]
   */
  renderPickupTimesTableHeader() {
    const pickupTimesColumnNamesList = CONST.PICKUP_TIMES_TABLE_THEAD_VALUES

    let headerJSX = []

    pickupTimesColumnNamesList.forEach(colName => {
      headerJSX.push(
        <Th className={colName} key={`pickup-header-${colName}`}>
          {colName}
        </Th>,
      )
    })

    return (
      <thead>
        <Tr>{headerJSX}</Tr>
      </thead>
    )
  }

  /**
   * Renders pickupTimes rows
   * @returns JSX.Element[]
   */
  renderPickupTimesTableRows() {
    const pickupTimes = this.props.pickupTimesList || []
    let rowsJSX = []
    pickupTimes.forEach((pickupTime, index) => {
      rowsJSX.push(this.renderPickupTimesTableRow(pickupTime, index))
    })

    return <tbody>{rowsJSX}</tbody>
  }

  /**
   * Renders pickupTimes table row
   * @returns JSX.Element[]
   */
  renderPickupTimesTableRow(pickupTime, index) {
    return (
      <Tr
        key={`${pickupTime.day}-${pickupTime.timeStart}-${pickupTime.timeStop}`}
      >
        <Td
          className="day col-xs-2"
          key={`day-${pickupTime.day}-${pickupTime.timeStart}-${
            pickupTime.timeStop
          }`}
        >
          {pickupTime.day}
        </Td>
        <Td
          className="timeStart col-xs-2"
          key={`timeStart-${pickupTime.day}-${pickupTime.timeStart}-${
            pickupTime.timeStop
          }`}
        >
          {this.formatTime(pickupTime.timeStart)}
        </Td>
        <Td
          className="timeStop col-xs-2"
          key={`timeStop-${pickupTime.day}-${pickupTime.timeStart}-${
            pickupTime.timeStop
          }`}
        >
          {this.formatTime(pickupTime.timeStop)}
        </Td>
        <Td
          className="actions"
          key={`actions-${pickupTime.day}-${pickupTime.timeStart}-${
            pickupTime.timeStop
          }`}
        >
          <LinkDelete
            onClickHandler={this.props.removePickupTime.bind(null, index)}
          />
        </Td>
      </Tr>
    )
  }

  /**
   * Format time to the following format 9 AM, 10 PM
   * @param timeString
   */
  formatTime(timeString) {
    return moment(timeString, CONST.TIME_FORMATS.HOURS_MINUTES_SECONDS).format(
      CONST.TIME_FORMATS.HOURS_MINUTES,
    )
  }
}

ManagePickupTimes.propTypes = {
  getPickupTimesByCityId: PropTypes.func.isRequired,
  savePickupTimesList: PropTypes.func.isRequired,
  removePickupTime: PropTypes.func.isRequired,
  pickupTimesList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      day: PropTypes.string.isRequired,
      timeStart: PropTypes.string,
      timeStop: PropTypes.string,
    }),
  ),
}

const mapStateToProps = state => ({
  pickupTimesList: state.pickupTimes.pickupTimesList.sort(sortTimesItems),
  initialPickupTimesList: state.pickupTimes.initialPickupTimesList,
  city: state.city.cityById,
})

export default connect(
  mapStateToProps,
  {
    getPickupTimesByCityId,
    removePickupTime,
    savePickupTimesList,
    cancelPickupTime,
  },
)(ManagePickupTimes)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/PickupTimes/index.js